<template>
  <b-modal
    id="viewDetailsModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showModal"
    @hidden="$emit('close-modal')"
  >
    <div
      class="
        b-modal-header
        d-flex
        align-items-center
        justify-content-between
        px-4
        py-3
      "
    >
      <div>Details</div>
      <img
        class="pointer rotate-on-hover"
        src="../../assets/panelist/blue_cross.svg"
        alt=""
        @click="$emit('close-modal')"
      />
    </div>
    <hr class="m-0" />
    <div class="w-100 relativeclass px-4 py-3 vd-overflow">
      <div
        class="d-flex flex-column add-details-gap mb-3"
        v-for="(value, key) in details"
        :key="key"
      >
        <div class="view-heading">{{ formatKey(key) }}</div>
        <div v-if="key === 'amount'" class="amount-card">
          <img :src="getImage()" alt="" />
          <span>{{ value }}</span>
        </div>
        <div v-else class="view-subheading">{{ value }}</div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "viewDetailsModal",
  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      details: {},
      paymentStatus: null,
    };
  },
  watch: {
    detailInfo: {
      handler(newValue) {
        if (newValue) {
          this.details = {
            customerName: newValue.customerName,
            jobName: newValue.jobName,
            candidateName: newValue.name,
            recruiterName: newValue.recruiter,
            round: `${newValue.interviewLevel}, ${newValue.interviewName}`,
            interviewDateTime: newValue.slot,
            amount: newValue.amount,
          };
          this.paymentStatus = newValue.paymentStatus;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getImage() {
      let img;
      if (this.paymentStatus == 1)
        img = require("../../assets/img/money-icon.svg");
      else if (this.paymentStatus == 2)
        img = require("../../assets/img/green-money-icon.svg");
      else if (this.paymentStatus == 0 || this.paymentStatus == 3)
        img = require("../../assets/img/red-money-icon.svg");
      else img = require("../../assets/img/money-icon.svg");
      return img;
    },
    formatKey(key) {
      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
    },
  },
};
</script>

<style scoped>
.vd-overflow {
  /* height: calc(100vh - 325px); */
  overflow: auto;
  min-height: auto;
  max-height: calc(100vh - 325px);
}
.add-details-gap {
  gap: 5px;
}

.view-heading {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #3a3c40;
}

.view-subheading {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #3a3c40;
}
</style>
